import { ReactNode } from 'react'

import { AlertsSummary } from './AlertsSummary.types'

export function AlertsColumnTooltip({ value }: { value: AlertsSummary }) {
  const { has_docs_expired, has_docs_close_to_expire, days_until_expiration } = value

  let tooltipContent: undefined | ReactNode
  const showExpiredIcon = has_docs_expired
  const showCloseToExpireIcon = has_docs_close_to_expire && days_until_expiration > 0

  if (showExpiredIcon) {
    tooltipContent = <p>This deal has documents that have already expired.</p>
  } else if (showCloseToExpireIcon) {
    tooltipContent = (
      <p>This deal has documents expiring within the next {days_until_expiration} days.</p>
    )
  }

  if (tooltipContent) {
    return (
      <div className='bg-gray-900 rounded py-2 px-2.5 shadow-md text-white w-56'>
        {tooltipContent}
      </div>
    )
  }

  return null
}
